import { endPointCaderno } from "../../models/constantes"


/**
 * Implementação do serviço de unidades (IoC - 100% desacoplado)
 * Todas as dependências são injetadas via constructor
 */
class UnidadeService {
  /**
   * Construtor com injeção de dependências via argumentos ordenados
   * Argumentos vêm na ordem definida no array dependencies: ["unidadeEndPoint", "useWebProvider"]
   */
  constructor(endPoint, useWebInterface) {

    this.webInterface = useWebInterface
    this.controller = this.webInterface({baseEndPoint: endPoint}) // Será obtido via webProvider quando necessário

  }



  async create(unidadeData) {
    try {
      const result = await this.controller.post("/unidade", unidadeData)
      return result
    } catch (error) {
      console.error('Erro ao criar unidade:', error)
      throw error
    }
  }

  async update(id, unidadeData) {
    try {
      const result = await this.controller.put(`/unidade/${id}`, unidadeData)
      // Refresh automático via websocket se disponível
      return result
    } catch (error) {
      console.error('Erro ao atualizar unidade:', error)
      throw error
    }
  }

  async getById(id) {
    try {
      return await this.controller.read(`/unidade/${id}`)
    } catch (error) {
      console.error('Erro ao buscar unidade:', error)
      throw error
    }
  }

  async delete(id) {
    try {
      const result = await this.controller.delete(`/unidade/${id}`)
      return result
    } catch (error) {
      console.error('Erro ao deletar unidade:', error)
      throw error
    }
  }

  async loadUnidades() {
    try {
      // Buscar do servidor
      const unidades = await this.controller.get("/unidade")
      return unidades || []
    } catch (error) {
      console.error('Erro ao carregar unidades:', error)
      return []
    }
  }

  /**
   * Refresh do cache via websocket (para sincronização em tempo real)
   */
  async refreshCache() {
    try {
      const unidades = await this.controller.readAll()
      return unidades
    } catch (error) {
      console.error('Erro ao atualizar cache:', error)
      return []
    }
  }



  async validate(unidadeData) {
    const errors = {}

    if (!unidadeData.nome || unidadeData.nome.trim() === '') {
      errors.nome = 'Nome da unidade é obrigatório'
    }

    if (!unidadeData.label || unidadeData.label.trim() === '') {
      errors.label = 'Sigla da unidade é obrigatória'
    }

    if (!unidadeData.fatorSi || isNaN(parseFloat(unidadeData.fatorSi))) {
      errors.fatorSi = 'Fator de conversão é obrigatório e deve ser um número válido'
    }

    if (!unidadeData.unidadeBaseSi || unidadeData.unidadeBaseSi.trim() === '') {
      errors.unidadeBaseSi = 'Unidade base SI é obrigatória'
    }

    if (unidadeData.nome && unidadeData.nome.length > 100) {
      errors.nome = 'Nome deve ter no máximo 100 caracteres'
    }

    if (unidadeData.label && unidadeData.label.length > 10) {
      errors.label = 'Sigla deve ter no máximo 10 caracteres'
    }

    if (unidadeData.fatorSi && parseFloat(unidadeData.fatorSi) <= 0) {
      errors.fatorSi = 'Fator de conversão deve ser um número positivo'
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    }
  }




}

export { UnidadeService }
export default UnidadeService